import { render, staticRenderFns } from "./private_login.vue?vue&type=template&id=5baba274&scoped=true&"
import script from "./private_login.vue?vue&type=script&lang=js&"
export * from "./private_login.vue?vue&type=script&lang=js&"
import style0 from "./private_login.vue?vue&type=style&index=0&id=5baba274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baba274",
  null
  
)

export default component.exports